import { useFormik } from "formik";
import * as Yup from "yup";

import { Button, getInput } from "../../../components/ui";
import { useEntities } from "../../../hooks/useEntities";

const MakeAvailableBody = ({
  closeModal,
  ids,
  instanceId,
  makeAvailableInstance,
  makeAvailableInstanceError,
  makeAvailableInstanceLoading,
  navigate,
}) => {
  const handleUpdate = () => {
    const input = {
      description: formik?.values?.description,
      entityId: formik?.values?.entityId,
      ...(ids && ids.length > 0 && { ids: ids }),
      ...(ids?.length < 1 && { id: instanceId }),
    };
    makeAvailableInstance({
      variables: {
        input,
      },
      update: (cache, { data }) => {
        const { makeAvailableInstance: { success, reservationId } = {} } =
          data || {};
        if (success) {
          closeModal();
          formik?.resetForm();
          if (reservationId) {
            navigate(`/reservations/${reservationId}/details`);
          }
        }
      },
    });
  };

  const formik = useFormik({
    initialValues: {},
    validationSchema: Yup.object({
      entityId: Yup.string().required("Required"),
      description: Yup.string().required("Required"),
    }),
    onSubmit: handleUpdate,
  });

  const { entities } = useEntities();
  const inputs = [
    {
      label: "Entity",
      name: "entityId",
      type: "multi-select",
      options:
        entities?.edges?.map(item => {
          return { label: item.name, value: item.id };
        }) || [],
    },
    { label: "Description", name: "description", type: "textarea" },
  ];

  return (
    <div className="mt-4 flex flex-col">
      {!makeAvailableInstanceError && (
        <div className="mt-4 flex gap-4">
          {inputs?.map((item, index) => {
            return (
              <div key={index} className="flex w-full flex-col">
                {getInput({ ...item, formik })}
              </div>
            );
          })}
        </div>
      )}
      <div className="mt-8 flex">
        <Button
          className="mr-3"
          label={makeAvailableInstanceError ? "Close" : "Cancel"}
          action={makeAvailableInstanceError ? "primary" : "default"}
          onClick={() => {
            closeModal?.();
            formik?.resetForm();
          }}
        />
        {!makeAvailableInstanceError && (
          <Button
            label={makeAvailableInstanceLoading ? "Updating" : "Update"}
            disabled={makeAvailableInstanceLoading}
            onClick={formik?.submitForm}
          />
        )}
      </div>
    </div>
  );
};

export default MakeAvailableBody;
